const sharps = [-75, -60, -80, -65, -50, -70, -55];
export default sharps;
